interface IFields {
    label: string;
    field: string;
    type: string;
    value: string | number | Date;
    searchType: any;
}

export class Child {
    id: number;
    firstName: string;
    lastName: string;
    classId: number;
    className: string;
    fatherId: number;
    motherId: number;
    birthday: string;
    parentId: number;
    parentName: string;
    parentSurName: string;
    parentEmail: string;
    parentDisplayName: string;
    fields: IFields[];

    constructor() {
        this.fields = [];
        this.fields = [{label: 'Όνομα μαθητή', field: 'firstName', type: 'text', value: '', searchType: ''},
            {label: 'Επώνυμο μαθητή', field: 'lastName', type: 'text', value: '', searchType: ''},
            {label: 'Όνομα πατέρα', field: 'father_first_name', type: 'text', value: '', searchType: ''},
            {label: 'Επώνυμο πατέρα', field: 'father_last_name', type: 'text', value: '', searchType: ''},
            {label: 'Όνομα μητέρας', field: 'mother_first_name', type: 'text', value: '', searchType: ''},
            {label: 'Επώνυμο μητέρας', field: 'mother_last_name', type: 'text', value: '', searchType: ''},
            {label: 'Ημερομηνία Γέννησης', field: 'birthday', type: 'date', value: '', searchType: ''}];
    }

    findChildren(): Child[] {
        const myChildren: Child[] = [];

        return myChildren;
    }

    getSearchFields(hasExternalChildren: boolean) {
        if (!hasExternalChildren) {
            const classID = {label: 'Τάξη', field: 'classId', type: 'select', value: '', searchType: ''};
            this.fields.push(classID);
        } else {
            const classID = {label: 'Τάξη', field: 'college_class_id', type: 'select', value: '', searchType: ''};
            const schoolUnit = {label: 'Σχολική μονάδα', field: 'college_school_id', type: 'select', value: '', searchType: ''};
            const schoolLevel = {label: 'Σχολείο', field: 'college_school_level', type: 'select', value: '', searchType: ''};
            const schoolClassDepartment = {label: 'Τμήμα', field: 'college_department_id', type: 'select', value: '', searchType: ''};
            this.fields.push(classID, schoolUnit, schoolLevel, schoolClassDepartment);
        }

        return this.fields;
    }
}

